import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_H1-6.scss';

const createHComponent = componentName => {
  /**
   * A header element (h1-6) component which wraps a HTML h1-6 and adds to it the basic bootstrap css rules.
   * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML h1-6 element.
   */
  const H = props => {
    const { className, innerRef, ...rest } = props;
    const classes = classNames(`B360${componentName.toUpperCase()}`, className);
    return React.createElement(componentName, { ...rest, className: classes, ref: innerRef });
  };

  H.propTypes = {
    /**
     * A custom className for the component
     */
    className: PropTypes.string,
    /**
     * a ref handled by the native html element
     */
    innerRef: PropTypes.func
  };

  H.displayName = componentName.toUpperCase();

  return H;
};

export const H1 = createHComponent('h1');
export const H2 = createHComponent('h2');
export const H3 = createHComponent('h3');
export const H4 = createHComponent('h4');
export const H5 = createHComponent('h5');
export const H6 = createHComponent('h6');
